module.exports = __webpack_public_path__ + "img/event_total_observers.cb02a6b0.svg";